// Desteklenen para birimleri — backend'deki api/src/currencies.ts ile aynı liste.
export type Currency = { code: string; symbol: string };

export const CURRENCIES: Currency[] = [
  { code: 'USD', symbol: '$' },
  { code: 'EUR', symbol: '€' },
  { code: 'GBP', symbol: '£' },
  { code: 'TRY', symbol: '₺' },
  { code: 'JPY', symbol: '¥' },
  { code: 'CNY', symbol: '¥' },
  { code: 'INR', symbol: '₹' },
  { code: 'BRL', symbol: 'R$' },
  { code: 'CAD', symbol: 'CA$' },
  { code: 'AUD', symbol: 'A$' },
  { code: 'CHF', symbol: 'CHF' },
  { code: 'SEK', symbol: 'kr' },
  { code: 'MXN', symbol: 'MX$' },
  { code: 'AED', symbol: 'د.إ' },
  { code: 'KRW', symbol: '₩' },
];

const SYMBOL_BY_CODE: Record<string, string> = Object.fromEntries(CURRENCIES.map((c) => [c.code, c.symbol]));

// Bilinmeyen kod gelirse (ör. henüz senkron olmamış eski istemci) koda düşer.
export function formatMoney(amount: number, code: string | null | undefined, language?: string): string {
  return `${symbolFor(code)}${formatMoneyAmount(amount, language)}`;
}

/**
 * Dakika başına fiyat her yerde tek biçimde (7.6 · D-663): "₺2,00 / dk".
 * Batuhan, "dakika başına" mı "/ dk" mı sorusuna: "Dk". Birim dilin kısa
 * dakika kısaltmasıdır (`calendar.minutesShort`); profildeki fiyat listesi
 * zaten böyle yazıyordu.
 */
export function formatPerMinute(
  amount: number,
  code: string | null | undefined,
  language: string | undefined,
  minuteUnit: string,
): string {
  return `${formatMoney(amount, code, language)} / ${minuteUnit}`;
}

// Amount-only presentation for fields that already render their currency separately.
export function formatMoneyAmount(amount: number, language?: string): string {
  // Mevcut iki basamaklı yuvarlama korunur; yalnız gösterim dili değişir.
  // Dil geçmeyen mevcut çağıranlar önceki sunumlarını korur.
  const fixed = Number(amount).toFixed(2);
  if (language && Number.isFinite(Number(amount))) {
    try {
      const localized = new Intl.NumberFormat(language, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: false,
      }).format(Number(fixed));
      return localized;
    } catch {
      // Eski runtime/bozuk locale tutarın gösterilmesini engellemesin.
    }
  }
  return fixed;
}

export function symbolFor(code: string | null | undefined): string {
  return (code && SYMBOL_BY_CODE[code]) || code || '$';
}
